<div class="dialog-content-wrapper fav-icon-dialog-wrapper">
  <mat-toolbar class="mat-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title text-xl text-black m-0">Update Profile</span>
      <button mat-icon-button (click)="matDialogRef.close(['cancel'])" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button> 
    </mat-toolbar-row>
  </mat-toolbar>

  <div>
    <div class="p-6 m-0 scroll-fix-height">
      @if(errorMessage!=null){
          <div class="message-box error mb-2">
            {{errorMessage}}
          </div>
        }
      <div class="mb-2">
        <button mat-button type="button" color="primary" class="profile-editbtn w-100-p" (click)="onClickTriggerFileInput()"> <mat-icon>cloud_upload</mat-icon> {{uploadButtonText}}</button>
      </div>
      <input type="file" id="fileUpload" #fileUpload name="fileUpload" accept="image/*" (change)="fileChangeListener($event)" style="display: none;" />
      <div >
        <img-cropper #cropper [image]="data" [settings]="cropperSettings"></img-cropper>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 pt-0 p-3 mat-action-fav border-top" fxLayout="row" fxLayoutAlign="flex-end center">
    <button mat-raised-button class="save-button mat-primary" (click)="matDialogRef.close(['submit',data])" [disabled]="isInvalidFile">Submit</button>
    <button mat-button (click)="matDialogRef.close(['cancel'])" color="warn">Cancel</button>
  </div>
</div>
